export const gameName = 'turbopoker';
export const socketGamePath = 'game';
export const socketLobbyPath = 'lobby';
export const socketTurboPath = 'turbo';
